import { TemplateCategory } from "./types";

export const empresarialCategory: TemplateCategory = {
  id: "empresarial",
  name: "Direito Empresarial",
  emoji: "💼",
  description: "Documentos para questões empresariais e societárias",
  subcategories: [
    {
      id: "direito-societario",
      name: "Direito Societário",
      emoji: "🏢",
      templates: [
        {
          id: "acao-dissolucao-parcial-sociedade",
          name: "Ação de Dissolução Parcial de Sociedade",
          type: "Petição Inicial",
          description: "Modelo para ação de dissolução parcial de sociedade empresária",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

em face de [NOME DOS DEMAIS SÓCIOS], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. A sociedade [RAZÃO SOCIAL] foi constituída em [DATA], tendo como sócios o(a) requerente e os requeridos, conforme contrato social anexo.

2. O capital social é de R$ [VALOR], sendo a participação do(a) requerente de [PERCENTUAL]%.

3. [DESCREVER OS MOTIVOS PARA A DISSOLUÇÃO - ex: divergências entre sócios, impossibilidade de continuidade da sociedade, etc.]

4. O(a) requerente manifesta sua vontade de se retirar da sociedade, exercendo o direito de recesso.

5. Não foi possível chegar a um acordo amigável para a dissolução parcial.

6. É necessária a apuração de haveres para determinar o valor devido ao(a) requerente.

II - DO DIREITO

O artigo 1.029 do Código Civil assegura aos sócios o direito de se retirar da sociedade nos casos previstos no contrato social ou por justa causa.

O artigo 1.031 do Código Civil estabelece que, nos casos de retirada, exclusão ou morte do sócio, o valor da sua quota será liquidado com base na situação patrimonial da sociedade.

A dissolução parcial é direito potestativo do sócio que não deseja mais participar da sociedade.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação dos requeridos para, querendo, contestar a presente ação;
b) A procedência dos pedidos para declarar a dissolução parcial da sociedade;
c) A apuração de haveres mediante perícia contábil;
d) A condenação dos requeridos ao pagamento dos haveres apurados;
e) A alteração do contrato social com a retirada do(a) requerente;
f) A condenação dos requeridos nos ônus da sucumbência;
g) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR ESTIMADO DOS HAVERES].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "acao-exclusao-socio",
          name: "Ação de Exclusão de Sócio",
          type: "Petição Inicial",
          description: "Modelo para ação de exclusão de sócio por justa causa",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

em face de [NOME DO SÓCIO], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. A sociedade requerente foi constituída em [DATA], tendo como sócios a requerente e o requerido, conforme contrato social anexo.

2. O requerido possui [PERCENTUAL]% das quotas sociais, representando R$ [VALOR] do capital social.

3. [DESCREVER OS ATOS PRATICADOS PELO SÓCIO QUE JUSTIFICAM A EXCLUSÃO]:
   - Descumprimento grave das obrigações sociais;
   - Prática de atos que comprometem a reputação da sociedade;
   - Violação das cláusulas contratuais;
   - [OUTROS MOTIVOS ESPECÍFICOS]

4. Foi tentativa de solução amigável através de [DESCREVER TENTATIVAS], sem êxito.

5. A permanência do sócio na sociedade tornou-se incompatível com os interesses sociais.

6. Está configurada a justa causa para exclusão prevista no contrato social e na lei.

II - DO DIREITO

O artigo 1.085 do Código Civil permite a exclusão de sócio por justa causa mediante alteração do contrato social.

O artigo 1.030 do Código Civil estabelece que o sócio pode ser excluído judicialmente por falta grave no cumprimento de suas obrigações.

A exclusão de sócio é medida excepcional que deve ser fundamentada em justa causa.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do requerido para contestar a presente ação;
b) A procedência dos pedidos para declarar a exclusão do sócio;
c) A apuração de haveres do sócio excluído;
d) A alteração do contrato social;
e) A condenação do requerido nos ônus da sucumbência;
f) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DAS QUOTAS DO SÓCIO].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "alteracao-contrato-social",
          name: "Alteração de Contrato Social",
          type: "Documento Societário",
          description: "Modelo para alteração de contrato social",
          icon: "FileText",
          content: `ALTERAÇÃO CONTRATUAL Nº [NÚMERO]

[RAZÃO SOCIAL], sociedade empresária, inscrita no CNPJ sob o nº [NÚMERO], com sede na [ENDEREÇO COMPLETO], por seus sócios abaixo qualificados e assinados, resolve alterar seu contrato social mediante as seguintes cláusulas:

SÓCIOS:

1. [NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito no CPF sob o nº [NÚMERO], residente e domiciliado na [ENDEREÇO];

2. [NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito no CPF sob o nº [NÚMERO], residente e domiciliado na [ENDEREÇO];

ALTERAÇÕES:

CLÁUSULA 1ª - [ESPECIFICAR A ALTERAÇÃO - ex: OBJETO SOCIAL]
[DESCREVER A NOVA REDAÇÃO DA CLÁUSULA]

CLÁUSULA 2ª - [ESPECIFICAR A ALTERAÇÃO - ex: CAPITAL SOCIAL]
[DESCREVER A NOVA REDAÇÃO DA CLÁUSULA]

CLÁUSULA 3ª - [ESPECIFICAR A ALTERAÇÃO - ex: ADMINISTRAÇÃO]
[DESCREVER A NOVA REDAÇÃO DA CLÁUSULA]

CLÁUSULA 4ª - CONSOLIDAÇÃO
Em virtude das alterações ora introduzidas, o contrato social passa a ter a seguinte redação consolidada:

[TEXTO CONSOLIDADO DO CONTRATO SOCIAL COM AS ALTERAÇÕES]

CLÁUSULA 5ª - DISPOSIÇÕES GERAIS
As demais cláusulas do contrato social permanecem inalteradas.

Esta alteração entra em vigor na data de sua assinatura.

E, por estarem assim justos e contratados, assinam o presente instrumento em [NÚMERO] vias de igual teor e forma, na presença das testemunhas abaixo.

[LOCAL], [DATA]

SÓCIOS:

_________________________________
[NOME DO SÓCIO 1]

_________________________________
[NOME DO SÓCIO 2]

TESTEMUNHAS:

_________________________        _________________________
Nome:                           Nome:
CPF:                           CPF:`
        }
      ]
    },
    {
      id: "recuperacao-falencia",
      name: "Recuperação e Falência",
      emoji: "⚖️",
      templates: [
        {
          id: "recuperacao-judicial-extrajudicial",
          name: "Recuperação Judicial e Extrajudicial",
          type: "Petição Inicial",
          description: "Modelo para pedido de recuperação judicial ou extrajudicial",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FALÊNCIAS E RECUPERAÇÕES JUDICIAIS DA COMARCA DE _____________

[RAZÃO SOCIAL], sociedade empresária, inscrita no CNPJ sob o nº [NÚMERO], com sede na [ENDEREÇO COMPLETO], neste ato representada por seu(s) administrador(es), vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base na Lei nº 11.101/2005, requerer

RECUPERAÇÃO JUDICIAL

pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. A requerente exerce regularmente atividade empresarial há mais de [TEMPO], conforme demonstram os documentos anexos.

2. A empresa encontra-se em dificuldades financeiras temporárias decorrentes de [DESCREVER AS CAUSAS - crise econômica, pandemia, problemas setoriais, etc.].

3. O passivo total da empresa é de R$ [VALOR], sendo que [PERCENTUAL]% refere-se a dívidas quirografárias.

4. A empresa possui viabilidade econômica, conforme demonstra o plano de recuperação anexo.

5. [DESCREVER A SITUAÇÃO FINANCEIRA E AS MEDIDAS JÁ ADOTADAS]

6. A recuperação judicial é a medida adequada para superar a crise e manter a atividade empresarial.

II - DO DIREITO

A Lei 11.101/2005 estabelece o instituto da recuperação judicial para empresas em crise econômico-financeira.

O artigo 47 da Lei de Recuperação e Falência estabelece como objetivo a manutenção da fonte produtora, do emprego dos trabalhadores e dos interesses dos credores.

Estão preenchidos os requisitos do artigo 48 da Lei 11.101/2005.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) O processamento do pedido de recuperação judicial;
b) A concessão do stay period (suspensão das ações e execuções);
c) A nomeação de administrador judicial;
d) A convocação da Assembleia Geral de Credores;
e) A aprovação do plano de recuperação judicial;
f) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DO PASSIVO].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Plano de recuperação judicial
- Demonstrações financeiras dos últimos 3 anos
- Certidões negativas
- Relação de credores
- Outros documentos exigidos pela Lei 11.101/2005`
        },
        {
          id: "pedido-falencia",
          name: "Pedido de Falência",
          type: "Petição Inicial",
          description: "Modelo para pedido de decretação de falência",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FALÊNCIAS E RECUPERAÇÕES JUDICIAIS DA COMARCA DE _____________

[NOME/RAZÃO SOCIAL DO CREDOR], [QUALIFICAÇÃO COMPLETA], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 94 da Lei nº 11.101/2005, requerer a

DECRETAÇÃO DE FALÊNCIA

de [RAZÃO SOCIAL DA DEVEDORA], sociedade empresária, inscrita no CNPJ sob o nº [NÚMERO], com sede na [ENDEREÇO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. A requerente é credora da requerida pela importância de R$ [VALOR], vencida e não paga.

2. O crédito está representado por [TÍTULO - duplicata, nota promissória, contrato, etc.], conforme documento anexo.

3. O título foi protestado em [DATA] no [CARTÓRIO DE PROTESTO].

4. A requerida foi devidamente notificada para pagamento em [DATA], permanecendo inerte.

5. [DESCREVER OUTROS ATOS DE FALÊNCIA, SE HOUVER]

6. Estão configurados os requisitos legais para a decretação da falência.

II - DO DIREITO

O artigo 94, I da Lei 11.101/2005 estabelece que a falência será decretada quando o devedor, sem relevante razão de direito, não paga, no vencimento, obrigação líquida materializada em título ou títulos executivos protestados cuja soma ultrapasse o equivalente a 40 salários-mínimos na data do pedido de falência.

O não pagamento de obrigação líquida, certa e exigível caracteriza ato de falência.

O protesto é pressuposto processual para o pedido de falência baseado em título executivo.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação da requerida para, em 24 horas, efetuar o pagamento ou apresentar defesa;
b) Não sendo contestado ou rejeitada a defesa, a decretação da falência;
c) A nomeação de administrador judicial;
d) A arrecadação dos bens da massa falida;
e) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DO CRÉDITO].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Título executivo
- Certidão de protesto
- Comprovante de notificação
- Procuração`
        },
        {
          id: "impugnacao-credito-falencia",
          name: "Impugnação de Crédito em Falência",
          type: "Petição",
          description: "Modelo para impugnação de crédito habilitado em falência",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FALÊNCIAS E RECUPERAÇÕES JUDICIAIS DA COMARCA DE _____________

[NOME/RAZÃO SOCIAL], [QUALIFICAÇÃO COMPLETA], nos autos da Falência de [RAZÃO SOCIAL DA FALIDA], Processo nº [NÚMERO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 8º da Lei nº 11.101/2005, apresentar

IMPUGNAÇÃO DE CRÉDITO

contra [NOME DO CREDOR IMPUGNADO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O crédito impugnado foi habilitado no valor de R$ [VALOR], classificado como [CLASSIFICAÇÃO].

2. [DESCREVER OS MOTIVOS DA IMPUGNAÇÃO]:
   - O crédito é inexistente por [MOTIVO];
   - OU: O valor está incorreto, sendo o correto R$ [VALOR];
   - OU: A classificação está equivocada, devendo ser [CLASSIFICAÇÃO CORRETA];
   - OU: O crédito está prescrito;
   - OU: Houve pagamento em [DATA].

3. [DESENVOLVER ARGUMENTAÇÃO ESPECÍFICA CONFORME O CASO]

4. A impugnação é procedente pelos fundamentos expostos.

II - DO DIREITO

O artigo 8º da Lei 11.101/2005 estabelece o procedimento para impugnação de créditos habilitados.

[CITAR LEGISLAÇÃO ESPECÍFICA CONFORME O FUNDAMENTO DA IMPUGNAÇÃO]

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A intimação do credor impugnado para manifestação;
b) [PEDIDO ESPECÍFICO CONFORME O CASO]:
   - A exclusão do crédito da relação de credores;
   - OU: A retificação do valor para R$ [VALOR];
   - OU: A reclassificação do crédito como [CLASSIFICAÇÃO];
c) Os demais pedidos de direito.

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        }
      ]
    },
    {
      id: "cobranca-titulos",
      name: "Cobrança e Títulos",
      emoji: "💳",
      templates: [
        {
          id: "contestacao-acao-cobranca-empresarial",
          name: "Contestação em Ação de Cobrança Empresarial",
          type: "Contestação",
          description: "Modelo para contestação em ação de cobrança empresarial",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[RAZÃO SOCIAL], sociedade empresária, inscrita no CNPJ sob o nº [NÚMERO], com sede na [ENDEREÇO COMPLETO], já qualificada nos autos da Ação de Cobrança nº [NÚMERO DO PROCESSO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, tempestivamente, apresentar sua

CONTESTAÇÃO

pelos fatos e fundamentos jurídicos a seguir expostos:

I - PRELIMINARES

1. [SE APLICÁVEL: INCOMPETÊNCIA DO JUÍZO - O foro competente seria o de [LOCAL] conforme cláusula contratual/local do cumprimento da obrigação]

2. [SE APLICÁVEL: INÉPCIA DA INICIAL - A petição inicial não atende aos requisitos do artigo 319 do CPC]

3. [SE APLICÁVEL: FALTA DE INTERESSE DE AGIR - Ausência de necessidade/adequação/utilidade]

II - DO MÉRITO

1. A requerida impugna integralmente os fatos narrados na inicial.

2. [DEFESA ESPECÍFICA CONFORME O CASO]:
   - O pagamento foi realizado em [DATA] conforme comprovante anexo;
   - OU: O débito está prescrito nos termos do artigo [ARTIGO] do Código Civil;
   - OU: Não há relação jurídica entre as partes que justifique a cobrança;
   - OU: Os valores cobrados são inexigíveis por [MOTIVO];
   - OU: Houve novação/compensação/transação que extinguiu a obrigação.

3. [DESCREVER OS FUNDAMENTOS ESPECÍFICOS DA DEFESA]

4. O pedido é improcedente por ausência de prova do alegado direito.

III - DO PEDIDO CONTRAPOSTO / RECONVENÇÃO

[SE APLICÁVEL: A requerida possui crédito em face da requerente no valor de R$ [VALOR] referente a [DESCRIÇÃO], requerendo seja a requerente condenada ao pagamento]

IV - DOS PEDIDOS

Ante o exposto, requer-se:

a) O acolhimento das preliminares arguidas;
b) A improcedência total dos pedidos iniciais;
c) [SE HOUVER: A procedência do pedido contraposto];
d) A condenação da requerente nos ônus da sucumbência;
e) Os demais pedidos de direito.

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Comprovantes de pagamento
- Contratos
- Correspondências
- Outros documentos pertinentes`
        },
        {
          id: "acao-monitoria-duplicata",
          name: "Ação Monitória de Duplicata",
          type: "Petição Inicial",
          description: "Modelo para ação monitória baseada em duplicata",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[RAZÃO SOCIAL], sociedade empresária, inscrita no CNPJ sob o nº [NÚMERO], com estabelecimento na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 700 do Código de Processo Civil, propor a presente

AÇÃO MONITÓRIA

em face de [NOME/RAZÃO SOCIAL], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. A requerente forneceu mercadorias/prestou serviços ao(à) requerido(a) conforme nota fiscal nº [NÚMERO], emitida em [DATA].

2. Em contrapartida ao fornecimento, foi emitida a duplicata de venda mercantil/prestação de serviços nº [NÚMERO], no valor de R$ [VALOR], com vencimento em [DATA].

3. A duplicata foi enviada ao(à) devedor(a) para aceite, mas não foi devolvida.

4. O valor permanece em aberto, caracterizando inadimplemento contratual.

5. [DESCREVER EVENTUAIS TENTATIVAS DE COBRANÇA AMIGÁVEL]

6. A prova escrita justifica a expedição de mandado monitório.

II - DO DIREITO

O artigo 700 do CPC permite a ação monitória com base em prova escrita sem eficácia de título executivo.

A duplicata não aceita, acompanhada de prova da efetiva entrega das mercadorias ou prestação dos serviços, constitui prova escrita suficiente para a ação monitória.

A Lei nº 5.474/68 regula a emissão e circulação das duplicatas.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A expedição de mandado monitório para que o(a) requerido(a) pague a importância de R$ [VALOR], acrescida de juros, correção monetária e honorários advocatícios;
b) Não sendo pago no prazo legal, a conversão em mandado executivo;
c) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Duplicata
- Nota fiscal
- Comprovante de entrega das mercadorias/prestação dos serviços
- Procuração`
        },
        {
          id: "pedido-levantamento-protesto",
          name: "Pedido de Levantamento de Protesto",
          type: "Requerimento",
          description: "Modelo para pedido de levantamento de protesto",
          icon: "FileText",
          content: `AO(À) EXCELENTÍSSIMO(A) SENHOR(A) TABELIÃO(Ã) DO [NÚMERO]º TABELIONATO DE PROTESTO DE TÍTULOS DA COMARCA DE _____________

[NOME/RAZÃO SOCIAL], [QUALIFICAÇÃO COMPLETA], vem, respeitosamente, perante Vossa Senhoria, por meio de seu advogado infra-assinado, com base no artigo 26 da Lei nº 9.492/97, apresentar

PEDIDO DE LEVANTAMENTO DE PROTESTO

referente ao título [DESCRIÇÃO DO TÍTULO] nº [NÚMERO], protestado em [DATA] sob o nº [NÚMERO DO PROTESTO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O título acima identificado foi protestado em [DATA] por falta de [pagamento/aceite/devolução].

2. [DESCREVER O MOTIVO DO LEVANTAMENTO]:
   - O débito foi quitado em [DATA] conforme comprovante anexo;
   - OU: O título foi protestado indevidamente, pois [MOTIVO];
   - OU: Houve acordo entre as partes para quitação da dívida;
   - OU: O título foi pago antes do protesto, mas não foi retirado em tempo hábil.

3. [ANEXAR DOCUMENTOS COMPROBATÓRIOS DA QUITAÇÃO OU IRREGULARIDADE]

4. O protesto deve ser cancelado para regularizar a situação do devedor.

II - DO DIREITO

O artigo 26 da Lei 9.492/97 estabelece que o cancelamento do protesto será solicitado diretamente no Tabelionato de Protesto de Títulos, por qualquer interessado, mediante apresentação do documento protestado, ou declaração de anuência do credor, ou por determinação judicial.

O artigo 43, § 3º da Lei 8.078/90 (CDC) determina que os órgãos de proteção ao crédito devem comunicar a baixa da negativação em até 5 dias úteis.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) O cancelamento do protesto do título acima identificado;
b) A expedição de certidão comprobatória do cancelamento;
c) A comunicação aos órgãos de proteção ao crédito sobre o cancelamento;
d) Os demais pedidos de direito.

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Original do título protestado ou declaração de anuência do credor
- Comprovante de pagamento
- Procuração
- Outros documentos pertinentes`
        },
        {
          id: "contestacao-execucao-titulo-extrajudicial-empresarial",
          name: "Contestação em Execução de Título Extrajudicial Empresarial",
          type: "Contestação",
          description: "Modelo para contestação em execução de título extrajudicial empresarial",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[RAZÃO SOCIAL], sociedade empresária, inscrita no CNPJ sob o nº [NÚMERO], com sede na [ENDEREÇO COMPLETO], já qualificada nos autos da Execução de Título Extrajudicial nº [NÚMERO DO PROCESSO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, no prazo legal, apresentar

EMBARGOS À EXECUÇÃO

pelos fatos e fundamentos jurídicos a seguir expostos:

I - PRELIMINARES

1. [SE APLICÁVEL: INCOMPETÊNCIA DO JUÍZO - conforme cláusula de eleição de foro ou regras de competência]

2. [SE APLICÁVEL: NULIDADE DA CITAÇÃO - vícios no ato citatório]

3. [SE APLICÁVEL: EXCESSO DE EXECUÇÃO - o valor executado excede o devido]

II - DO MÉRITO

1. A executada impugna integralmente a execução pelos seguintes fundamentos:

2. [DEFESAS ESPECÍFICAS CONFORME O CASO]:

a) PAGAMENTO: O débito foi quitado em [DATA] conforme comprovante anexo, caracterizando extinção da obrigação;

b) PRESCRIÇÃO: O direito do exequente está prescrito, pois transcorreram mais de [PRAZO] anos desde o vencimento da obrigação;

c) NOVAÇÃO: As partes celebraram novação da dívida, substituindo a obrigação original;

d) COMPENSAÇÃO: A executada possui crédito líquido e certo contra o exequente no valor de R$ [VALOR];

e) NULIDADE DO TÍTULO: O título executivo apresenta vícios que comprometem sua executividade;

f) AUSÊNCIA DE LIQUIDEZ, CERTEZA E EXIGIBILIDADE: O título não preenche os requisitos do art. 783 do CPC.

3. [DESENVOLVER A ARGUMENTAÇÃO ESPECÍFICA CONFORME A DEFESA ESCOLHIDA]

4. A execução deve ser extinta por [MOTIVO ESPECÍFICO].

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) O acolhimento das preliminares arguidas;
b) A procedência dos embargos para [PEDIDO ESPECÍFICO - extinção da execução, redução do valor, etc.];
c) A condenação do embargado nos ônus da sucumbência;
d) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Comprovantes de pagamento
- Contratos e aditivos
- Correspondências
- Outros documentos pertinentes`
        }
      ]
    },
    {
      id: "contratos-empresariais",
      name: "Contratos Empresariais",
      emoji: "📄",
      templates: [
        {
          id: "contrato-fornecimento",
          name: "Contrato de Fornecimento",
          type: "Contrato",
          description: "Modelo para contrato de fornecimento de produtos ou serviços",
          icon: "FileText",
          content: `CONTRATO DE FORNECIMENTO

CONTRATANTE: [RAZÃO SOCIAL], sociedade empresária, inscrita no CNPJ sob o nº [NÚMERO], com sede na [ENDEREÇO COMPLETO], neste ato representada por [NOME DO REPRESENTANTE], [QUALIFICAÇÃO];

CONTRATADA: [RAZÃO SOCIAL], sociedade empresária, inscrita no CNPJ sob o nº [NÚMERO], com sede na [ENDEREÇO COMPLETO], neste ato representada por [NOME DO REPRESENTANTE], [QUALIFICAÇÃO];

As partes acima qualificadas celebram o presente CONTRATO DE FORNECIMENTO, que se regerá pelas seguintes cláusulas e condições:

CLÁUSULA 1ª - DO OBJETO
1.1. A CONTRATADA obriga-se a fornecer à CONTRATANTE [DESCRIÇÃO DOS PRODUTOS/SERVIÇOS], conforme especificações constantes do Anexo I deste contrato.

1.2. O fornecimento será realizado conforme cronograma estabelecido no Anexo II.

CLÁUSULA 2ª - DO PREÇO E FORMA DE PAGAMENTO
2.1. O valor total do contrato é de R$ [VALOR] ([VALOR POR EXTENSO]).

2.2. O pagamento será efetuado [FORMA DE PAGAMENTO - à vista, parcelado, etc.] mediante [MEIO DE PAGAMENTO].

2.3. Os pagamentos vencerão em [DATAS DE VENCIMENTO].

CLÁUSULA 3ª - DO PRAZO E LOCAL DE ENTREGA
3.1. O prazo para entrega é de [PRAZO] dias contados da assinatura deste contrato.

3.2. A entrega será realizada no seguinte local: [ENDEREÇO DE ENTREGA].

3.3. O frete [CORRERÁ POR CONTA DE QUEM].

CLÁUSULA 4ª - DAS OBRIGAÇÕES DA CONTRATADA
4.1. Fornecer os produtos/serviços dentro dos padrões de qualidade estabelecidos;
4.2. Cumprir rigorosamente os prazos de entrega;
4.3. Responsabilizar-se pela qualidade dos produtos/serviços fornecidos;
4.4. [OUTRAS OBRIGAÇÕES ESPECÍFICAS].

CLÁUSULA 5ª - DAS OBRIGAÇÕES DA CONTRATANTE
5.1. Efetuar os pagamentos nas datas estabelecidas;
5.2. Receber os produtos/serviços no local e prazo convencionados;
5.3. Comunicar eventuais defeitos ou não conformidades;
5.4. [OUTRAS OBRIGAÇÕES ESPECÍFICAS].

CLÁUSULA 6ª - DA GARANTIA
6.1. A CONTRATADA garante os produtos/serviços pelo prazo de [PRAZO DA GARANTIA].

6.2. A garantia abrange [ESPECIFICAR O QUE ESTÁ COBERTO].

CLÁUSULA 7ª - DAS PENALIDADES
7.1. O descumprimento de qualquer cláusula contratual sujeitará a parte infratora ao pagamento de multa de [PERCENTUAL]% sobre o valor total do contrato.

7.2. A mora no pagamento sujeitará o devedor ao pagamento de juros de [PERCENTUAL]% ao mês e correção monetária.

CLÁUSULA 8ª - DA RESCISÃO
8.1. O contrato poderá ser rescindido:
a) Por acordo entre as partes;
b) Por inadimplemento de qualquer das partes;
c) [OUTRAS HIPÓTESES DE RESCISÃO].

CLÁUSULA 9ª - DO FORO
9.1. Fica eleito o foro da comarca de [CIDADE/UF] para dirimir quaisquer controvérsias oriundas deste contrato.

E, por estarem assim justos e contratados, assinam o presente instrumento em duas vias de igual teor e forma, na presença das testemunhas abaixo.

[LOCAL], [DATA]

CONTRATANTE:                    CONTRATADA:

_____________________          _____________________
[NOME E CARGO]                 [NOME E CARGO]

TESTEMUNHAS:

_____________________          _____________________
Nome:                          Nome:
CPF:                          CPF:`
        },
        {
          id: "contrato-representacao-comercial",
          name: "Contrato de Representação Comercial",
          type: "Contrato",
          description: "Modelo para contrato de representação comercial",
          icon: "FileText",
          content: `CONTRATO DE REPRESENTAÇÃO COMERCIAL

REPRESENTADA: [RAZÃO SOCIAL], sociedade empresária, inscrita no CNPJ sob o nº [NÚMERO], com sede na [ENDEREÇO COMPLETO], neste ato representada por [NOME DO REPRESENTANTE], [QUALIFICAÇÃO];

REPRESENTANTE: [NOME/RAZÃO SOCIAL], [PESSOA FÍSICA OU JURÍDICA], inscrito no CPF/CNPJ sob o nº [NÚMERO], [ENDEREÇO COMPLETO], registrado no CORE sob o nº [NÚMERO];

As partes acima qualificadas celebram o presente CONTRATO DE REPRESENTAÇÃO COMERCIAL, que se regerá pelas seguintes cláusulas e condições:

CLÁUSULA 1ª - DO OBJETO
1.1. A REPRESENTADA outorga ao REPRESENTANTE a representação comercial para venda de [PRODUTOS/SERVIÇOS] na região de [DEFINIR TERRITÓRIO].

1.2. A representação é [EXCLUSIVA/NÃO EXCLUSIVA] para o território estabelecido.

CLÁUSULA 2ª - DO TERRITÓRIO
2.1. O território de atuação do REPRESENTANTE compreende [DELIMITAR ÁREA GEOGRÁFICA].

2.2. É [VEDADO/PERMITIDO] ao REPRESENTANTE atuar fora do território estabelecido.

CLÁUSULA 3ª - DAS OBRIGAÇÕES DO REPRESENTANTE
3.1. Promover a venda dos produtos da REPRESENTADA em seu território;
3.2. Manter cadastro atualizado de clientes;
3.3. Prestar informações sobre o mercado e concorrência;
3.4. Cumprir as diretrizes comerciais da REPRESENTADA;
3.5. [OUTRAS OBRIGAÇÕES ESPECÍFICAS].

CLÁUSULA 4ª - DAS OBRIGAÇÕES DA REPRESENTADA
4.1. Fornecer material promocional e treinamento;
4.2. Entregar os produtos vendidos nos prazos estabelecidos;
4.3. Pagar as comissões devidas;
4.4. Prestar suporte técnico e comercial;
4.5. [OUTRAS OBRIGAÇÕES ESPECÍFICAS].

CLÁUSULA 5ª - DA COMISSÃO
5.1. O REPRESENTANTE fará jus à comissão de [PERCENTUAL]% sobre o valor líquido das vendas efetivadas.

5.2. A comissão será paga até o [DIA] do mês seguinte ao faturamento.

5.3. Não haverá direito à comissão sobre vendas canceladas ou não pagas.

CLÁUSULA 6ª - DAS METAS
6.1. O REPRESENTANTE compromete-se a atingir meta mínima mensal de R$ [VALOR].

6.2. O não cumprimento da meta por [PERÍODO] consecutivos poderá ensejar a rescisão do contrato.

CLÁUSULA 7ª - DO PRAZO
7.1. O presente contrato tem prazo de [PRAZO], podendo ser renovado por acordo entre as partes.

7.2. Qualquer das partes poderá denunciar o contrato mediante aviso prévio de [PRAZO].

CLÁUSULA 8ª - DA RESCISÃO
8.1. O contrato poderá ser rescindido:
a) Por denúncia de qualquer das partes;
b) Por justa causa;
c) Por descumprimento das obrigações contratuais.

8.2. Na rescisão sem justa causa, a parte denunciante pagará indenização equivalente a [VALOR/FÓRMULA].

CLÁUSULA 9ª - DO FORO
9.1. Fica eleito o foro da comarca de [CIDADE/UF] para dirimir quaisquer controvérsias oriundas deste contrato.

E, por estarem assim justos e contratados, assinam o presente instrumento em duas vias de igual teor e forma, na presença das testemunhas abaixo.

[LOCAL], [DATA]

REPRESENTADA:                   REPRESENTANTE:

_____________________          _____________________
[NOME E CARGO]                 [NOME]

TESTEMUNHAS:

_____________________          _____________________`
        }
      ]
    },
    {
      id: "responsabilidade-empresarial",
      name: "Responsabilidade Empresarial",
      emoji: "⚠️",
      templates: [
        {
          id: "acao-responsabilidade-administrador",
          name: "Ação de Responsabilidade de Administrador",
          type: "Petição Inicial",
          description: "Modelo para ação de responsabilização de administrador de sociedade",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[RAZÃO SOCIAL/NOME], [QUALIFICAÇÃO COMPLETA], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base nos artigos 1.016 e seguintes do Código Civil, propor a presente

AÇÃO DE RESPONSABILIDADE DE ADMINISTRADOR

em face de [NOME DO ADMINISTRADOR], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O requerido foi administrador da sociedade [RAZÃO SOCIAL] no período de [PERÍODO].

2. Durante sua gestão, o requerido praticou os seguintes atos irregulares:
   [DESCREVER DETALHADAMENTE OS ATOS PRATICADOS]:
   - Atos praticados com excesso de poderes ou infração à lei ou ao contrato social;
   - Operações prejudiciais à sociedade;
   - Aplicação inadequada de recursos sociais;
   - [OUTROS ATOS ESPECÍFICOS]

3. Em razão dos atos praticados, a sociedade/sócios sofreram prejuízos no valor de R$ [VALOR].

4. [DESCREVER AS CONSEQUÊNCIAS DOS ATOS E OS PREJUÍZOS CAUSADOS]

5. O requerido agiu com culpa/dolo na condução dos negócios sociais.

6. Há nexo causal entre os atos praticados e os danos causados.

II - DO DIREITO

O artigo 1.016 do Código Civil estabelece que os administradores respondem solidariamente perante a sociedade e os terceiros prejudicados por culpa no desempenho de suas funções.

O artigo 1.017 do Código Civil dispõe sobre a ação de responsabilidade contra os administradores.

A responsabilidade do administrador é subjetiva, dependendo da comprovação de culpa ou dolo.

O administrador tem o dever de agir com diligência e lealdade no interesse da sociedade.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do requerido para contestar a presente ação;
b) A procedência dos pedidos para condenar o requerido ao pagamento de indenização no valor de R$ [VALOR];
c) A condenação ao pagamento de juros, correção monetária e honorários advocatícios;
d) A condenação do requerido nos ônus da sucumbência;
e) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Contrato social e alterações
- Demonstrações financeiras
- Atas de assembleia
- Comprovantes dos prejuízos
- Procuração`
        }
      ]
    }
  ]
};
